import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "reports" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-2"
}
const _hoisted_4 = { class: "container-item-report" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "color-grey-5 mt-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-2"
}
const _hoisted_9 = { class: "container-item-report" }
const _hoisted_10 = { class: "text-xl font-bold" }
const _hoisted_11 = { class: "color-grey-5 mt-2" }
const _hoisted_12 = ["onClick"]

import HjpDataList from '@/views/components/list/HjpDataList.vue'
import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import InlineSvg from 'vue-inline-svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListReportAdvance',
  setup(__props) {

const endpoint = 'transaction/v1/MsDynamicReports'

const store = useStore()
const route = useRoute()
const router = useRouter()
const paramsDataList = ref({
  endpoint,
  fieldSearch: ['query'],
  showAddBtn: false,
  headerTitle: 'Laporan Advanced'
})

const rolesName = localStorage.getItem('rn')
const externalReportId = '6fe45dfb-3bfc-4955-4ee2-08dba83ae69a'

const goDetail = (item: any) => {
  const routeData = router.resolve({ name: 'reports-detail', params: { typeReport: item.Query } })
  window.open(routeData.href, '_blank')
}

onMounted(() => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Laporan Excel & Data',
      routeName: 'reports'
    },
    {
      title: 'Laporan',
      routeName: `${route.name as string}`
    },
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HjpDataList, _normalizeProps(_guardReactiveProps(paramsDataList.value)), {
      content: _withCtx(({ dataItems }) => [
        (_unref(rolesName) === 'External')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                  (item.Id === externalReportId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_unref(Card), { class: "card-no-shadow" }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_unref(InlineSvg), {
                                src: require('@/assets/img/icon/printer-outline-black.svg'),
                                class: "mb-2"
                              }, null, 8, ["src"]),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(item.Judul), 1),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(item.Keterangan), 1),
                              _createElementVNode("p", {
                                class: "text-primary font-bold mt-2 cursor-pointer",
                                onClick: ($event: any) => (goDetail(item))
                              }, "Details & Download", 8, _hoisted_7)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataItems, (item, idx) => {
                return (_openBlock(), _createBlock(_unref(Card), {
                  key: idx,
                  class: "card-no-shadow"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(InlineSvg), {
                        src: require('@/assets/img/icon/printer-outline-black.svg'),
                        class: "mb-2"
                      }, null, 8, ["src"]),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(item.Judul), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(item.Keterangan), 1),
                      _createElementVNode("p", {
                        class: "text-primary font-bold mt-2 cursor-pointer",
                        onClick: ($event: any) => (goDetail(item))
                      }, "Details & Download", 8, _hoisted_12)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
      ]),
      _: 1
    }, 16)
  ]))
}
}

})